module.exports = __webpack_public_path__ + "img/sdg2_jp.5d0b699c.png";